var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showInToolbar)?_c('v-tabs',{attrs:{"background-color":"orange","color":"success","center-active":""},model:{value:(_vm.activeTabIndex),callback:function ($$v) {_vm.activeTabIndex=$$v},expression:"activeTabIndex"}},_vm._l((_vm.items),function(item,index){return _c('v-tab',{key:index},[_vm._v(" "+_vm._s(item.caption)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }